import { render, staticRenderFns } from "./player.create.vue?vue&type=template&id=30228de6&scoped=true&"
import script from "./player.create.vue?vue&type=script&lang=ts&"
export * from "./player.create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30228de6",
  null
  
)

export default component.exports